import update from 'immutability-helper';
import _findIndex from 'lodash/findIndex';
import _filter from 'lodash/filter';

import {
    FETCHING_ITEMS,
    FETCHED_ITEMS,
    SET_ITEMS_GRID_PER_PAGE_RECORDS,
    SET_ITEMS_GRID_CURRENT_PAGE,
    SET_ITEMS_GRID_SORT_CRITERIA,
    SET_ITEMS_GRID_FILTER_CRITERIA,
    SET_GRID_FILTER,
    UNSET_GRID_FILTER,
} from './types';

/** these initializations should be dynamic **/
const INITIAL_STATE = {
    usersGrid: {
        loading: false,
        totalPages: 0,
        currentPage: 0,
        perPage: 10,
        sorted: [{id: 'id', desc: true}],
        filtered: [],
    },
    pagesGrid: {
        loading: false,
        totalPages: 0,
        currentPage: 0,
        perPage: 10,
        sorted: [{id: 'id', desc: false}],
        filtered: [],
    },
    pageTemplatesGrid: {
        loading: false,
        totalPages: 0,
        currentPage: 0,
        perPage: 10,
        sorted: [{id: 'id', desc: true}],
        filtered: [],
    },
    blocksGrid: {
        loading: false,
        totalPages: 0,
        currentPage: 0,
        perPage: 10,
        sorted: [{id: 'id', desc: false}],
        filtered: [],
    },
    staffGrid: {
        loading: false,
        totalPages: 0,
        currentPage: 0,
        perPage: 10,
        sorted: [{id: 'id', desc: false}],
        filtered: [],
    },
    labelsGrid: {
        loading: false,
        totalPages: 0,
        currentPage: 0,
        perPage: 10,
        sorted: [{id: 'id', desc: false}],
        filtered: [],
    },
    redirectsGrid: {
        loading: false,
        totalPages: 0,
        currentPage: 0,
        perPage: 10,
        sorted: [{id: 'id', desc: false}],
        filtered: [],
    },
    tagsGrid: {
        loading: false,
        totalPages: 0,
        currentPage: 0,
        perPage: 10,
        sorted: [{id: 'id', desc: false}],
        filtered: [],
    },
    faqsGrid: {
        loading: false,
        totalPages: 0,
        currentPage: 0,
        perPage: 10,
        sorted: [{id: 'id', desc: false}],
        filtered: [],
    },
    webinarsGrid: {
        loading: false,
        totalPages: 0,
        currentPage: 0,
        perPage: 10,
        sorted: [{id: 'id', desc: false}],
        filtered: [],
    },
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCHING_ITEMS:
            return update(state, {
                $merge: {
                    [action.payload.gridId]: update(
                        state[action.payload.gridId],
                        {
                            loading: {$set: action.payload.loading},
                        }
                    ),
                },
            });

        case FETCHED_ITEMS:
            return update(state, {
                [action.payload.gridId]: {
                    $set: update(state[action.payload.gridId], {
                        totalPages: {$set: action.payload.totalPages},
                        loading: {$set: false},
                    }),
                },
            });

        case SET_ITEMS_GRID_PER_PAGE_RECORDS:
            return update(state, {
                $merge: {
                    [action.payload.gridId]: update(
                        state[action.payload.gridId],
                        {
                            perPage: {$set: action.payload.perPage},
                        }
                    ),
                },
            });

        case SET_ITEMS_GRID_CURRENT_PAGE:
            return update(state, {
                $merge: {
                    [action.payload.gridId]: update(
                        state[action.payload.gridId],
                        {
                            currentPage: {$set: action.payload.currentPage},
                        }
                    ),
                },
            });

        case SET_ITEMS_GRID_SORT_CRITERIA:
            return update(state, {
                $merge: {
                    [action.payload.gridId]: update(
                        state[action.payload.gridId],
                        {
                            sorted: {$set: action.payload.sorted},
                        }
                    ),
                },
            });

        case SET_ITEMS_GRID_FILTER_CRITERIA:
            return update(state, {
                $merge: {
                    [action.payload.gridId]: update(
                        state[action.payload.gridId],
                        {
                            filtered: {$set: action.payload.filtered},
                        }
                    ),
                },
            });

        case UNSET_GRID_FILTER:
            let filteredUnset = state[action.payload.gridId].filtered;

            filteredUnset = _filter(filteredUnset, (filter) => {
                return filter.id !== action.payload.filterId;
            });

            return update(state, {
                $merge: {
                    [action.payload.gridId]: update(
                        state[action.payload.gridId],
                        {
                            filtered: {$set: filteredUnset},
                            currentPage: {$set: 0},
                        }
                    ),
                },
            });

        case SET_GRID_FILTER:
            let filtered = state[action.payload.gridId].filtered;

            let filterIndex = _findIndex(filtered, {
                id: action.payload.filterId,
            });

            if (filterIndex === -1) {
                filtered = update(filtered, {
                    $push: [
                        {
                            id: action.payload.filterId,
                            value: action.payload.value,
                        },
                    ],
                });
            } else {
                filtered = update(filtered, {
                    $merge: {
                        [filterIndex]: {
                            id: action.payload.filterId,
                            value: action.payload.value,
                        },
                    },
                });
            }

            return update(state, {
                $merge: {
                    [action.payload.gridId]: update(
                        state[action.payload.gridId],
                        {
                            filtered: {$set: filtered},
                            currentPage: {$set: 0},
                        }
                    ),
                },
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/grid/reducer.js